export default "__VITE_ASSET__DhFDVsa___"